import { OnboardingStep } from './types';

export const steps = [
	'Basic Information',
	'Professional Details',
	'Work Logistics',
	'Vehicle & Travel',
	'Travel Preferences',
	'Representation',
	'Review',
];

export const stateOptions = [
	{ id: 'AL', display: 'Alabama' },
	{ id: 'AK', display: 'Alaska' },
	{ id: 'AZ', display: 'Arizona' },
	{ id: 'AR', display: 'Arkansas' },
	{ id: 'CA', display: 'California' },
	{ id: 'CO', display: 'Colorado' },
	{ id: 'CT', display: 'Connecticut' },
	{ id: 'DE', display: 'Delaware' },
	{ id: 'FL', display: 'Florida' },
	{ id: 'GA', display: 'Georgia' },
	{ id: 'HI', display: 'Hawaii' },
	{ id: 'ID', display: 'Idaho' },
	{ id: 'IL', display: 'Illinois' },
	{ id: 'IN', display: 'Indiana' },
	{ id: 'IA', display: 'Iowa' },
	{ id: 'KS', display: 'Kansas' },
	{ id: 'KY', display: 'Kentucky' },
	{ id: 'LA', display: 'Louisiana' },
	{ id: 'ME', display: 'Maine' },
	{ id: 'MD', display: 'Maryland' },
	{ id: 'MA', display: 'Massachusetts' },
	{ id: 'MI', display: 'Michigan' },
	{ id: 'MN', display: 'Minnesota' },
	{ id: 'MS', display: 'Mississippi' },
	{ id: 'MO', display: 'Missouri' },
	{ id: 'MT', display: 'Montana' },
	{ id: 'NE', display: 'Nebraska' },
	{ id: 'NV', display: 'Nevada' },
	{ id: 'NH', display: 'New Hampshire' },
	{ id: 'NJ', display: 'New Jersey' },
	{ id: 'NM', display: 'New Mexico' },
	{ id: 'NY', display: 'New York' },
	{ id: 'NC', display: 'North Carolina' },
	{ id: 'ND', display: 'North Dakota' },
	{ id: 'OH', display: 'Ohio' },
	{ id: 'OK', display: 'Oklahoma' },
	{ id: 'OR', display: 'Oregon' },
	{ id: 'PA', display: 'Pennsylvania' },
	{ id: 'RI', display: 'Rhode Island' },
	{ id: 'SC', display: 'South Carolina' },
	{ id: 'SD', display: 'South Dakota' },
	{ id: 'TN', display: 'Tennessee' },
	{ id: 'TX', display: 'Texas' },
	{ id: 'UT', display: 'Utah' },
	{ id: 'VT', display: 'Vermont' },
	{ id: 'VA', display: 'Virginia' },
	{ id: 'WA', display: 'Washington' },
	{ id: 'WV', display: 'West Virginia' },
	{ id: 'WI', display: 'Wisconsin' },
	{ id: 'WY', display: 'Wyoming' },
];

export const countryOptions = [
	{ id: 'US', display: 'United States' },
	{ id: 'CA', display: 'Canada' },
	{ id: 'MX', display: 'Mexico' },
	{ id: 'GB', display: 'United Kingdom' },
	{ id: 'IE', display: 'Ireland' },
	{ id: 'AU', display: 'Australia' },
	{ id: 'NZ', display: 'New Zealand' },
	{ id: 'FR', display: 'France' },
	{ id: 'DE', display: 'Germany' },
	{ id: 'IT', display: 'Italy' },
	{ id: 'ES', display: 'Spain' },
	{ id: 'JP', display: 'Japan' },
	{ id: 'KR', display: 'South Korea' },
	{ id: 'CN', display: 'China' },
	{ id: 'IN', display: 'India' },
	{ id: 'BR', display: 'Brazil' },
	{ id: 'AR', display: 'Argentina' },
	// Add more countries as needed
];

export const defaultPreferredAirlines = {
	alaskan: false,
	american: false,
	delta: false,
	frontier: false,
	klm: false,
	southwest: false,
	united: false,
	virgin: false,
};

export const airlineOptions = [
	{ id: 'Alaska', display: 'Alaska' },
	{ id: 'American', display: 'American' },
	{ id: 'Delta', display: 'Delta' },
	{ id: 'Frontier', display: 'Frontier' },
	{ id: 'JetBlue', display: 'JetBlue' },
	{ id: 'Southwest', display: 'Southwest' },
	{ id: 'Spirit', display: 'Spirit' },
	{ id: 'United', display: 'United' },
];

export const hotelOptions = [
	{ id: 'Hilton', display: 'Hilton' },
	{ id: 'Marriott Bonvoy', display: 'Marriott Bonvoy' },
	{ id: 'Hyatt', display: 'Hyatt' },
	{ id: 'IHG', display: 'IHG' },
	{ id: 'Best Western', display: 'Best Western' },
	{ id: 'Choice Hotels', display: 'Choice Hotels' },
];

export const carRentalOptions = [
	{ id: 'Avis', display: 'Avis' },
	{ id: 'Budget', display: 'Budget' },
	{ id: 'Enterprise', display: 'Enterprise' },
	{ id: 'Hertz', display: 'Hertz' },
	{ id: 'National', display: 'National' },
	{ id: 'Alamo', display: 'Alamo' },
];

export const rideSharingOptions = [
	{ id: 'Uber', display: 'Uber' },
	{ id: 'Lyft', display: 'Lyft' },
	{ id: 'Waymo', display: 'Waymo' },
];
